import { makeStyles } from "@material-ui/core/styles";

const marginTopList = 22;
const fontSizeTitle = 18;

const useStyles = makeStyles(() => ({
  orderList: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    width: "50%",
  },

  title: {
    fontSize: fontSizeTitle,
    fontWeight: "bold",
    color: "#FFF",
  },

  list: {
    minHeight: 0,
    overflowY: "auto",
    overscrollBehaviorY: "contain",
    marginTop: marginTopList,
    paddingBottom: 15,
    paddingRight: 28,
  },
}));

export default useStyles;
